import React from 'react';
import Header from './components/Header/Index';
import Heroslider from './components/Heroslider/Index';
import Data from './Json/Home.json';
import About from './components/Aboutus/Index';
import Residences from './components/Residences/Index';
import Featureslider from './components/Gallery/Featureslider';
import Gallery from './components/Gallery/GallerySlider';
import Numbers from './components/Counter/Numbers';
import BusinessEnquiry from './components/Forms/BusinessEnquiry';
import Footer from './components/Footer/Index';
import Location from './components/Location/Index';

const Home = () => {
  return (
    <>
      <Header Data={Data.header} />
      <Heroslider Data={Data.heroBanner} Data2={Data.highlightsData} />
      <About Data={Data.aboutContent} />
      <Featureslider Data={Data.club} />
      <Residences Data={Data.residence} />
      <Location Data={Data.locationContent} />
      <Gallery Data={Data.gallery} />
      <Numbers countersData={Data.numberData} numberImage={Data.numberImage} />
      <BusinessEnquiry source = 'footer' />
      <Footer />
    </>
  );
};

export default Home;